<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import '@/assets/reset.css'
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  width:100vw;
  min-width: 1440px;
  height:100%;
  overflow-y:auto;
  .container{
    min-width: 1440px;
  }
  .nav-box{
    margin-top:800px;
    display: flex;
    height:30px;
    align-items: center;
    margin-left:200px;
    img{
        width:40px;
        height:40px;
        margin-top:-2px;
    }
    span{
        color:#263465;
        font-size: 18px;
        margin-right:5px;
    }
    /deep/ .el-breadcrumb{
        .el-breadcrumb__item span{
            color:#263465;
        }
        .el-breadcrumb__inner.is-link{
            font-weight: 400;
        }
    }
  }
  .beian{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue